import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { useTableStore } from "@/store/useTableStore";

function getBaseModule(pathname: string): string {
  const segments = pathname.split("/").filter(Boolean);
  if (segments.length === 0) return "/";
  return "/" + segments[0];
}

export function useModuleTracker() {
  const location = useLocation();
  const trackModuleNavigation = useTableStore(
    (state) => state.trackModuleNavigation
  );

  useEffect(() => {
    const baseModule = getBaseModule(location.pathname);
    trackModuleNavigation(baseModule);
  }, [location.pathname, trackModuleNavigation]);
}
